import React from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Tabs } from 'antd';
import { Users } from 'lucide-react';
import CustomerReport from './CustomerReport';
import { useI18n } from 'hooks/useI18n';

const Reports = () => {
	const { type } = useParams();
	const { t } = useI18n();

	const items = [
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					<Users size={16} style={{ marginRight: 6 }} />
					{t('reports.tabs.customers')}
				</span>
			),
			key: 'customer',
			children: <CustomerReport />,
		},
	];

	return (
		<Row className="customer-tab-container" style={{ height: '80%' }}>
			<Col span={24} className="container">
				<Tabs defaultActiveKey={type || 'customer'} destroyInactiveTabPane items={items} />
			</Col>
		</Row>
	);
};

export default Reports;
